import * as $ from "jquery";
import * as Swiper from 'swiper/dist/js/swiper.min';
import "gsap/TweenLite";

declare var TweenLite: any;

// TODO Move me
function slideChangeFunctions() {
	function slideChangeArrowsInit(element) {
		let $el = $(element);
		let actions = $el.data('slide-change');

		if (!actions) {
			return;
		}

		if (typeof(actions) === 'string') {
			actions = [{
				action: actions,
				target: $el.data('target'),
				delay: $el.data('delay') || 0
			}];
		}

		for (var i = 0; i < actions.length; i++) {
			let nextSequence = actions[i];
			let nextAction = nextSequence.action;
			let $nextTarget = $el.find(nextSequence.target) || $el;
			let delay = nextSequence.delay || 0;

			switch (nextAction) {
				case 'applyClass':
				case 'apply-class':
					TweenLite.delayedCall(delay, function () {
						let scrollClass = nextSequence.class;
						$nextTarget.addClass(scrollClass);
					});
					break;
				case 'removeClass':
				case 'remove-class':
					TweenLite.delayedCall(delay, function () {
						let scrollClass = nextSequence.class;
						$nextTarget.removeClass(scrollClass);
					});
					break;
			}
		}
	}

	slideChangeArrowsInit('.hero-rotator');

}

// TODO Move me
function initHeroRotator(){
	//Preload our faucet images so they pop in nice and fast when we transition
	var preloadImgs = [];
	$('.hero-rotator__list-item').each(function() {
		var img = new Image();
		img.src = $(this).data("img");
		if(img.src) {
			preloadImgs.push(img);
		}
	});

	// console.log(preloadImgs);

	//setup the carousel - multiple on one page
	var swiper = [];
	$('.js-hero-rotator').each(function(index, element){
		//setup some global variables for each instance;
		var parentRotator = $(this).parents('.hero-rotator');
		var slideImage = parentRotator.find('.js-callouts img');
		// var calloutLeft = parentRotator.find('.js-callout-left');
		// var calloutRight = parentRotator.find('.js-callout-right');
		// var calloutArrow = parentRotator.find('.hero-rotator__arrow');
		var rtCallouts = parentRotator.find('.hero-rotator__callout').addClass('state-visible');
		var $this = $(this);
		var sliderList = [];

		//setup each swiper instance
		var swiper = new Swiper(this,{
			// Optional parameters
			init: false,
			loop: true,
			slidesPerView: 1,
			preventInteractionOnTransition: true,
			autoplay: {
				delay: 5000,
			},

			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},

			// Navigation arrows
			navigation: {
				nextEl: $this.find('.swiper-button-next')[0],
				prevEl: $this.find('.swiper-button-prev')[0],
			}
		});

		//push up the swiper data
		sliderList.push(swiper);

		//on init set the current faucet image to the data-img src found on the item in the carousel
		swiper.on('init', function(){
			let slideImageSrc = $(swiper.slides[swiper.activeIndex]).data('img');
			let slideImageAlt = $(swiper.slides[swiper.activeIndex]).data('alt');
			let rotatorCallout = swiper.$el.parents('.hero-rotator').find('.js-callouts');
			rotatorCallout.attr('class', 'hero-rotator__callouts js-callouts hero-rotator__callouts--'+swiper.activeIndex);
			let $extendedContent = $(swiper.slides[swiper.activeIndex]).find('.js-extended-content');
			let $target = $(rotatorCallout).find($extendedContent.data('target'));
			rotatorCallout.find('img').attr({'src': slideImageSrc, 'alt': slideImageAlt});
			if($extendedContent.children().length > 0){
				$target.append($extendedContent.html());
			}

			slideChangeFunctions(); //animation on arrows
		});


		//when the transition on the carousel starts set the faucet to the new active element and replace the callout texts.
		//also create modifier classes based on active index.
		swiper.on('slideChangeTransitionStart', function(){
			let slideImageSrc = $(swiper.slides[swiper.activeIndex]).data('img');
			let slideImageAlt = $(swiper.slides[swiper.activeIndex]).data('alt');
			let prevSlideImageSrc = $(swiper.slides[swiper.previousIndex]).data('img');
			let prevSlideImageAlt = $(swiper.slides[swiper.previousIndex]).data('alt');
			let rotatorCallout = $(swiper.$el).parents('.hero-rotator').find('.js-callouts');
			let rotatorCalloutImg = rotatorCallout.find('img:not(.js-cloned-img)');
			let rotatorCalloutImgX = rotatorCalloutImg.offset().left;
			let rotatorCalloutImgY = rotatorCalloutImg.offset().top;

			if($(swiper.slides[swiper.animating])) {
				$(swiper.$el).parents('.hero-rotator').find('.swiper-button-next, .swiper-button-prev').on('click', function(){
					return false;
				});
			}

			rotatorCallout.attr('class', 'hero-rotator__callouts js-callouts hero-rotator__callouts--'+swiper.activeIndex);
			let $extendedContent = $(swiper.slides[swiper.activeIndex]).find('.js-extended-content');
			let $target = $(swiper.$el).parents('.hero-rotator').find($extendedContent.data('target'));

			//clone the image from the previous slide and append it
			rotatorCalloutImg.clone().addClass('js-cloned-img hero-rotator__img--cloned state-visible').css({"left" : +rotatorCalloutImgX+"px", "top" : rotatorCalloutImgY+"px"}).appendTo( $('body') );
			rotatorCalloutImg.css('visibility', 'hidden');
			let $clonedImg = rotatorCallout.find('.js-cloned-img');
			$clonedImg.attr({'src': prevSlideImageSrc, 'alt': prevSlideImageAlt});
			rotatorCalloutImg.attr({'src': slideImageSrc, 'alt': slideImageAlt});

			setTimeout(function(){
				$(swiper.$el).parents('.hero-rotator').find('.js-callouts img:not(.js-cloned-img)').removeAttr('style').addClass('state-visible');
				$('.js-cloned-img').removeClass('state-visible');
			}, 50);
			setTimeout(function(){
				$('.js-cloned-img').remove();
			}, 300);

			if($extendedContent.children().length > 0){
				$target.append($extendedContent.html());
				$target.children().removeClass('state-visible');
			}
		});

		swiper.on('slideChangeTransitionEnd', function(){
			let $extendedContent = $(swiper.slides[swiper.activeIndex]).find('.js-extended-content');
			let $target = $(swiper.$el).parents('.hero-rotator').find($extendedContent.data('target'));

			setTimeout(function(){
				$target.children().not('img').addClass('state-visible'); //make callouts visible
				slideChangeFunctions();
			}, 250);

		});

		$this.parents('.hero-rotator').on({
			mouseenter: function () {
				swiper.autoplay.stop();
			},

			mouseleave: function () {
				swiper.autoplay.start();
			}
		});

		swiper.init();
	});
}

export function init() {
	if($('.js-hero-rotator').length) {
		initHeroRotator();
	}
}



// WEBPACK FOOTER //
// ./js/PFF/modules/heroRotator.ts